/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Text, Icon, Image, Input, Loader, Checkbox, FormModal } from '../../../ui-kit';

import '../styles/_stock-assets-modal.scss';



















class AddToProjectModal extends Component {
  constructor(props) {
    super(props);
    const { projects } = props;
    const selectedItems = {};
    for (const { projectId } of projects) {
      selectedItems[projectId] = false;
    }
    this.state = {
      selectedItems,
      projectSearchInputValue: ''
    };
  }

  addAssetsToProjects = (selectedProjects) => {
    const { onSave } = this.props;
    onSave(selectedProjects);
  };

  handleSave = async () => {
    const { selectedItems } = this.state;
    const tempSelected = [];

    for (const [key, value] of Object.entries(selectedItems)) {
      if (value) {
        tempSelected.push({
          key,
          value
        });
      }
    }

    if (tempSelected.length !== 0) {
      this.addAssetsToProjects(tempSelected);
    }
  };

  handleClose = () => {
    const { onClose } = this.props;
    this.setState({ selectedItems: {} });
    onClose();
  };

  onSelectItem = (id) => () => {
    this.setState(({ selectedItems: latestItems }) => ({
      selectedItems: { ...latestItems, [id]: !latestItems[id] }
    }));
  };

  onLoadMore = async () => {
    const { projects, getProjects } = this.props;
    const { projectSearchInputValue } = this.state;

    getProjects({ offset: projects.length, query: projectSearchInputValue });
  };

  onFilterProjects = (e) => {
    const { setProjects, getProjects } = this.props;

    const searchInput = e.target.value.toLowerCase().trim();

    setProjects([]);
    this.setState({ projectSearchInputValue: searchInput });

    if (!searchInput) {
      getProjects({ offset: 0, limit: 20 });
    } else {
      getProjects({ query: searchInput, offset: 0, limit: 20 });
    }
  };

  modalLoading = () => {
    const { loadingSuccess } = this.props;
    return (
      <div className="add-assets-modal" style={{ width: 400, height: 300 }}>
        {loadingSuccess ?

        <div className="add-success-icon">
              <Icon name="success" size={40} color="monkey" />
              <Text heading3 style={{ paddingTop: 15 }}>Projects updated</Text>
            </div> :

        <Loader text="Adding to project" caption="Please wait while we add this asset to the selected projects" />}

      </div>);

  };

  getModalContent = () => {
    const { selectedItems, projectSearchInputValue } = this.state;
    const { totalProjectsCount, projectsCount, projects } = this.props;

    const selectedTotal = Object.values(selectedItems).filter(Boolean).length;
    const fetchedAllProjects = projectsCount === 0 || projects.length >= projectsCount;

    return (
      <div className="add-assets-modal">
        <Input
          id="add-assets-modal-search-input"
          placeholder="Search Projects"
          value={projectSearchInputValue}
          onChange={this.onFilterProjects} />

        <div
          style={{ marginTop: 20 }}
          className="stock-assets-modal__list"
          id="add-assets-modal-search-results-container">

          {projects.length ?

          <InfiniteScroll
            next={this.onLoadMore}
            dataLength={projects.length}
            hasMore={!fetchedAllProjects || !projectsCount}
            scrollableTarget="add-assets-modal-search-results-container"
            loader={<Loader hasNoBeforeShowTimeout />}>

                {projects.map((project) => {
              const {
                title,
                videoId,
                projectId,
                projectThumb
              } = project || {};

              return (
                <div
                  key={videoId}
                  className="stock-assets-modal__list__asset"
                  onClick={this.onSelectItem(videoId)}>

                      <Checkbox checked={Boolean(selectedItems[videoId])} />
                      <Image
                    imageUrl={projectThumb?.THUMBNAIL?.sourceUrl}
                    width={144}
                    height={80}
                    backgroundSize="contain"
                    default />

                      <div className="stock-assets-modal__list__asset__description">
                        <Text heading4 noMargin ellipsisOverflow>{title}</Text>
                        <Text noMargin ellipsisOverflow>{`Project ID: ${projectId}`}</Text>
                      </div>
                    </div>);

            })}
              </InfiniteScroll> :
          null}
        </div>
        <Text heading5 className="stock-assets-modal__summary">
          {`${selectedTotal} of ${totalProjectsCount} projects selected`}
        </Text>
      </div>);

  };

  render() {
    const { selectedAsset, loading } = this.props;
    const { selectedItems } = this.state;

    return (
      <FormModal
        visible
        stayOpenOnSave
        hideFooter={loading}
        showHeaderCloseButton={!loading}
        closeMaskOnClick={false}
        saveDisabled={Object.values(selectedItems).filter(Boolean).length === 0}
        onClose={this.handleClose}
        onSave={this.handleSave}
        saveText="Add Selected"
        title={loading ? null : 'Add to Project'}
        subtitle={loading ? null : `Asset ID: ${selectedAsset.id} - Select which projects you want to add this asset to.`}>

        {loading ? this.modalLoading() : this.getModalContent()}
      </FormModal>);

  }
}

export default AddToProjectModal;